import { SVGProps } from "react";

const IconInstallation = (props: SVGProps<SVGSVGElement>) => {
    const { className, ...rest } = props;

    return (
        <svg
            className={className}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            {...rest}
        >
            <path
                d="M13.0826 6.07607C12.909 6.25311 12.8118 6.49114 12.8118 6.73906C12.8118 6.98697 12.909 7.225 13.0826 7.40204L14.598 8.91743C14.775 9.09097 15.013 9.18818 15.2609 9.18818C15.5089 9.18818 15.7469 9.09097 15.9239 8.91743L19.4946 5.34679C19.9708 6.39922 20.115 7.5718 19.908 8.70826C19.7009 9.84472 19.1524 10.8911 18.3356 11.7079C17.5187 12.5247 16.4724 13.0732 15.3359 13.2803C14.1994 13.4874 13.0269 13.3432 11.9744 12.8669L5.42983 19.4115C5.05304 19.7883 4.54201 20 4.00915 20C3.47629 20 2.96525 19.7883 2.58847 19.4115C2.21168 19.0347 2 18.5237 2 17.9909C2 17.458 2.21168 16.947 2.58847 16.5702L9.13307 10.0256C8.65683 8.97314 8.51263 7.80056 8.71969 6.66409C8.92676 5.52763 9.47525 4.48127 10.2921 3.66444C11.1089 2.84761 12.1553 2.29911 13.2917 2.09205C14.4282 1.88498 15.6008 2.02918 16.6532 2.50542L13.092 6.0666L13.0826 6.07607Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default IconInstallation;
